import React from 'react';
import TicketEventsListWrapperV2 from 'flow/components/tickets/v2/TicketEventsListWrapperV2';
import MessageInputTicketV2 from 'flow/components/tickets/v2/MessageInputTicketV2';
import { TicketKey } from 'flow/types/EntityKeys';

interface Props {
    ticketKey: TicketKey;
    dateLabelBgClassName?: string;
    autoFocusInput?: boolean;
    // False while kept mounted but hidden (a side tab fills the ticket page's
    // main pane), so the ticket no longer counts as open on screen.
    visible?: boolean;
}

const ConversationTabContent = ({
    ticketKey,
    dateLabelBgClassName,
    autoFocusInput = true,
    visible = true,
}: Props) => (
    <div className="flex min-h-0 flex-1 flex-col">
        <div className="scrollbar scrollbar-gutter-stable flex min-h-0 flex-1 justify-center overflow-y-auto ps-4 pe-2">
            <div className="w-full max-w-[600px]">
                <TicketEventsListWrapperV2
                    key={`${ticketKey}-events`}
                    ticketKey={ticketKey}
                    dateLabelBgClassName={dateLabelBgClassName}
                    visible={visible}
                />
            </div>
        </div>
        <div className="flex justify-center px-4">
            <div className="w-full max-w-[600px] pt-1 pb-3">
                <MessageInputTicketV2
                    ticketKey={ticketKey}
                    autoFocus={autoFocusInput}
                />
            </div>
        </div>
    </div>
);

export default React.memo(ConversationTabContent);
